export default __webpack_public_path__ + "static/media/scoopS.cd26e3d4.png";